import { configureStore, combineReducers } from '@reduxjs/toolkit'
import authReducer from './authSlice'
import themeSettingReducer from './themeSlice'
import localeReducer from './langSlice'

const savedAuthState = localStorage.getItem('auth')
const initialState = savedAuthState
  ? { auth: JSON.parse(savedAuthState) }
  : undefined

const rootReducer = combineReducers({
  auth: authReducer,
  themeSetting: themeSettingReducer,
  locale: localeReducer,
})

export const store = configureStore({
  reducer: rootReducer,
  preloadedState: initialState,
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
